// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"V5-z","subtitle":"W5-z","wrapper":"X5-z","leftArrow":"Y5-z","rightArrow":"Z5-z"};